module.exports = __webpack_public_path__ + "components/flag/static/square/td-13c5605918dacb3c1aeec2a8cbe1c751.svg";